import React from 'react';
import {
  FDBox,
  FDPaper,
  FDStack,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

import useMobileLayout from 'Hooks/useMobileLayout';
import { TaxDiagnosticWrapperLayout } from 'Views/Page/Content/Templates/TaxDiagnosticCommon/TaxDiagnosticWrapperLayout';
import {
  TaxDiagnosticLottiePicker,
} from 'Views/Page/Content/Templates/TaxDiagnosticCommon/TaxDiagnosticLottie/TaxDiagnosticLottiePicker';
import { dataAttrs } from 'Helpers/Testing';


const Layout = () => {
  const isMobile = useMobileLayout();
  const { resource } = useMetaLayoutContext();

  return (
    <TaxDiagnosticWrapperLayout>
      <FDPaper padding={4} appearance={'elevated'} flex={2}>
        <FDStack
          direction={isMobile ? 'column' : 'row'}
          spacing={isMobile ? 2 : 4}
          alignItems={'center'}
          height={'100%'}
        >
          <FDBox flex={1}>
            <TaxDiagnosticLottiePicker resource={resource} />
          </FDBox>
          <FDStack direction={'column'} spacing={3} flex={2}>
            <MetaControlField attr="sectionTitle" {...dataAttrs('context-section-title')} />
            <MetaControlField attr="sectionDescription" />
          </FDStack>
        </FDStack>
      </FDPaper>
    </TaxDiagnosticWrapperLayout>
  );
};

Layout.defaultProps = {};

Layout.propTypes = {
};

export default Layout;
